export default __webpack_public_path__ + "static/media/logo.3ef2a111.png";